import { margin } from "ds_legacy/materials/metrics";
import {
  ActivableToggle,
  DatePickerWithLabel,
  SMALL_INPUT_WIDTH,
  TEXT_AREA_MAX_CHARACTERS,
  TextAreaWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const AftercareApplication = () => {
  const translations = useTranslations();
  return (
    <ActivableToggle
      componentIfFalse={
        <TextAreaWithLabel
          characterLimit={TEXT_AREA_MAX_CHARACTERS}
          elementName="aftercare_application_explanation"
          label={
            translations.patientForms.transitionalCareForm.sectionC
              .textFieldDescription
          }
          marginOverride={margin(0)}
          multiline
        />
      }
      componentIfTrue={
        <DatePickerWithLabel
          elementName="aftercare_application_date"
          inputSx={{ width: SMALL_INPUT_WIDTH }}
          isBold
          label={
            translations.patientForms.transitionalCareForm.sectionC
              .applicationDate
          }
          shouldDisableFuture
          wrapperSx={{ width: "100%" }}
        />
      }
      elementName="aftercare_application_submitted"
      label={
        translations.patientForms.transitionalCareForm.sectionC
          .applicationSubmitted
      }
      sideMutation={(value, mutate) => {
        if (!value) {
          return mutate(null, "aftercare_application_date");
        }

        return mutate(null, "aftercare_application_explanation");
      }}
    />
  );
};
